import React from "react";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Checkbox, ListItemText } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(() => ({
  select: {
    minWidth: 120,
    maxWidth: 190,
  },
}));

// Estética unificada de filtros (misma que el filtro "Estado...").
const filterSelectStyle = {
  fontSize: 11,
  height: 22,
  border: "1px solid rgba(0,0,0,0.18)",
  borderRadius: 10,
  padding: "0 4px",
  background: "transparent",
  opacity: 0.7,
};

const TicketsTagSelect = ({
  userTags = [],
  selectedTagIds = [],
  onChange,
}) => {
  const classes = useStyles();

  if (!userTags || userTags.length === 0) return null;

  const buildLabel = () => {
    if (selectedTagIds.length === 0) return i18n.t("ticketsList.filters.tagPlaceholder");
    if (selectedTagIds.length === 1) {
      const tag = userTags.find(t => t.id === selectedTagIds[0]);
      return tag ? tag.name : "1";
    }
    return i18n.t("ticketsList.filters.tagCount", { count: selectedTagIds.length });
  };

  const handleTagToggle = (tagId) => {
    const newIds = selectedTagIds.includes(tagId)
      ? selectedTagIds.filter(id => id !== tagId)
      : [...selectedTagIds, tagId];
    onChange(newIds);
  };

  return (
    <FormControl size="small" className={classes.select}>
      <Select
        multiple
        value={[]}
        displayEmpty
        disableUnderline
        renderValue={() => (
          <span style={{ fontSize: 11 }}>{buildLabel()}</span>
        )}
        style={filterSelectStyle}
        MenuProps={{
          getContentAnchorEl: null,
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
          PaperProps: { style: { maxHeight: 320 } },
        }}
        inputProps={{ style: { padding: "0 4px", fontSize: 11 } }}
      >
        {userTags.map(tag => (
          <MenuItem dense key={tag.id} onClick={() => handleTagToggle(tag.id)}>
            <Checkbox
              size="small"
              checked={selectedTagIds.includes(tag.id)}
              style={{ color: tag.color || "#6c757d" }}
            />
            <span
              style={{
                display: "inline-block",
                width: 8,
                height: 8,
                borderRadius: "50%",
                backgroundColor: tag.color || "#6c757d",
                marginRight: 6,
                flexShrink: 0,
              }}
            />
            <ListItemText
              primary={tag.name}
              primaryTypographyProps={{ style: { fontSize: 13 } }}
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TicketsTagSelect;
